export const defaultBlockSize = 10;
export class ElelementsIds {
    static logsElId = 'logs';
    static toggleLogsButtonId = 'toggleLogs';
    static canvasId = 'gameCanvas';
}
